module.exports = __webpack_public_path__ + "img/trunk_1x4_z16.ad846917.svg";